import {
  EXPAND_REPOSITORY,
  COLLAPSE_REPOSITORY,
  HIDE_REPOSITORY,
  SHOW_REPOSITORY,
  FULL_VIEW_REPOSITORY,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    repositorySize: 'default',
    repositoryHidden: false,
  };
};

const initialState = getInitialState();

const layout = (state = initialState, action) => {
  const types = {
    [EXPAND_REPOSITORY]: () => ({
      ...state,
      repositorySize: 'default',
    }),
    [COLLAPSE_REPOSITORY]: () => ({
      ...state,
      repositorySize: 'collapsed',
    }),
    [HIDE_REPOSITORY]: () => ({
      ...state,
      repositoryHidden: true,
    }),
    [SHOW_REPOSITORY]: () => ({
      ...state,
      repositoryHidden: false,
    }),
    [FULL_VIEW_REPOSITORY]: () => ({
      ...state,
      repositorySize: 'full',
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default layout;
